import PropTypes from 'prop-types';
import {generateTaskWellsLocation} from '../BroadcastTaskHelper';

function BroadcastTaskDescription({number, labware, tasks, labwareState}) {
  return (
    <>
      &nbsp;
      <span>{number === 1 ? 'from' : 'to'}</span>
      &nbsp;
      <span>{generateTaskWellsLocation(number, labware, tasks, labwareState)}</span>
    </>
  );
}

BroadcastTaskDescription.propTypes = {
  number: PropTypes.number,
  labware: PropTypes.object,
  labwareState: PropTypes.object,
  tasks: PropTypes.array,
};

BroadcastTaskDescription.defaultProps = {
  number: 0,
  labware: {},
  labwareState: {},
  tasks: [],
};

export default BroadcastTaskDescription;
